<template>
 <!-- 租主才能使用 -->
	<section>
		
		
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form  :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
			<!-- @keyup.enter.native="getMember" -->
				<el-form-item>
                <el-select  v-model="Comboid" clearable filterable  placeholder="请选择套餐" >
                <el-option
                  v-for="item in comboList"
                  :key="item.ComboId"
                  :label="item.ComboName"
                  :value="item.ComboId">
               </el-option>
                 </el-select>
				</el-form-item> 			
			   <el-form-item>
					<el-input  v-model="Telephone"  @keyup.enter.native="getMember" placeholder="号码"></el-input>
				</el-form-item>	
				<el-form-item>
					<el-input  v-model="CardNumber"  @keyup.enter.native="getMember" placeholder="卡号"></el-input>
				</el-form-item>			
				<el-form-item>
					<el-input  v-model="filters.Name"  @keyup.enter.native="getMember" placeholder="姓名"></el-input>
				</el-form-item>
				<el-form-item>
					<div class="block">
				<el-date-picker
placeholder="选择日期"
						v-model="filters.dateValue" 
							type="daterange"                       
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						>
				</el-date-picker>
				</div>
				</el-form-item>	
				<el-form-item>
					<el-button size="width:100%; height:100%;" type="primary" v-on:click="getMember" icon="el-icon-search">查询</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="handleAdd">添加会员业务卡</el-button>
				</el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handBackups">备份业务</el-button>
				</el-form-item>	
				<el-form-item>
					<el-button type="primary" @click="handBackData">导出数据</el-button>
				</el-form-item>						
			</el-form>
		</el-col>

		<!--列表-->
		<el-table  :data="Members" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width:1702px">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="ComboName" label="套餐名称" width="180" sortable>
			</el-table-column>	
			<el-table-column prop="CoachName" label="教练名称" min-width="120" sortable>
			</el-table-column>	

			<el-table-column prop="CardNumber" label="卡号" width="180" sortable>
			</el-table-column>
			<el-table-column prop="CreationTime" label="办理时间" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="FinalTime" label="业务截至时间" min-width="180" sortable>
			</el-table-column>					
			<el-table-column prop="Name" label="姓名" width="120" sortable  >
			     <template slot-scope="scope">
					 <div v-if="scope.row.CardType==4">
                 <el-popover trigger="hover" placement="right" @show="showShift(scope.row.Id)">
                 <p v-for="item in shiftList">{{ item }}</p>
                 <div slot="reference" >
                 <el-tag type="primary" size="medium">{{ scope.row.Name }}</el-tag>
                 </div>
                  </el-popover>
					 </div>
					 <div v-else>
                  <span>{{scope.row.Name}}</span>
				   </div>
                 </template>	
			</el-table-column>
			<el-table-column prop="Sex" label="性别" width="100" :formatter="formatSex" sortable>
			</el-table-column>
			<el-table-column prop="Calculation" label="年龄" width="100" sortable>
			</el-table-column>
			<el-table-column prop="Telephone" label="电话" width="150" sortable>
			</el-table-column>
			<!-- <el-table-column prop="Birthday" label="生日" width="120" sortable :formatter="formatDate">
			</el-table-column> -->
			<!-- <el-table-column prop="IdNumber" label="身份证号码" width="190" sortable>
			</el-table-column> -->
			<el-table-column prop="CardType" label="卡类型" min-width="100"  :formatter="formatType" sortable>
			</el-table-column>
			
			<el-table-column prop="ComboMoney" label="套餐价格" width="140" sortable>
				<template slot-scope="scope">
					{{ scope.row.ComboMoney?scope.row.ComboMoney+'(元)':'' }}
				</template>
			</el-table-column>
			<el-table-column prop="Amount" label="实收金额" width="140" sortable>
				<template slot-scope="scope">
					{{ scope.row.Amount?scope.row.Amount+'(元)':'' }}
				</template>
			</el-table-column>
			<el-table-column prop="Descriptions" label="状态描述" min-width="120" sortable>
			</el-table-column>
			<!-- <el-table-column prop="Height" label="身高cm" min-width="110" sortable>
			</el-table-column>
			<el-table-column prop="ArmLength" label="臂长cm" min-width="110" sortable>
			</el-table-column>
			<el-table-column prop="Weight" label="体重kg" min-width="110" sortable>
			</el-table-column>			 -->
			<!-- <el-table-column prop="State" label="状态" min-width="90" :formatter="formatState" sortable>
			</el-table-column>								 -->

			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="State" label="状态" width="100" sortable fixed="right">				  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="info" size="medium" v-if="scope.row.State==1">停用</el-tag>
                  <el-tag type="success" size="medium" v-else>正常</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column  label="是否停用" width="120" sortable fixed="right">
				<template slot-scope="scope">			
				<el-switch :ref="Members[scope.$index].Id"   v-model="Members[scope.$index].State==1?false:true" active-color="#13ce66" inactive-color="#ff4949" @change="SwitchChange(scope.row)" :disabled="false"></el-switch>
				 </template>
			</el-table-column>
			<el-table-column label="操作" min-width="240" fixed="right">
				<template  slot-scope="scope">
					<!-- <el-button size="small" type="primary" @click="imageShow(scope.$index, scope.row)">上传照片</el-button>
                    <el-button size="small" type="primary" @click="imagemanage(scope.$index, scope.row)">照片管理</el-button>					
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
					<el-button v-if="scope.row.CardType!=3&&scope.row.CardType!=5" size="small" @click="open(scope.row.Id)">延期</el-button>
					<el-button type="warning" size="small" @click="GetInFo(scope.row)">重置业务卡</el-button>
					<el-button v-if="scope.row.CardType==3" type="primary" size="small" @click="RechargeShow(scope.row)">续充</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-tag>当前有{{Count}}位会员</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
			    <!-- 查看图片 -->
        <el-dialog title="查看大图" v-model="seeImageVisible">
			<img   :src="imgUrl" style="height: 100%; width: 100%; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; ">
		</el-dialog>	
        <el-dialog id="tt" title="照片上传" v-model="imageVisible" >
             <el-upload
              class="upload-demo"
              drag action=""
              :http-request="upload"
              multiple customClass=".el-upload-dragger">
             <i class="el-icon-upload"></i>
             <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
             <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
		</el-dialog>			
		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="160px" :rules="editFormRules" ref="editForm" @submit.native.prevent>				
				<el-form-item label="卡号" prop="CardNumber">
					<el-input v-model="editForm.CardNumber" auto-complete="off" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="Name">
					<el-input v-model="editForm.Name" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="性别">
					<el-radio-group v-model="editForm.Sex" :disabled="true">
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>					
			    <el-form-item label="状态">
					<el-radio-group v-model="editForm.State">
						<el-radio class="radio" :label="1">暂停</el-radio>
						<el-radio class="radio" :label="0">启用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄:生日">
					<el-input-number v-model="editForm.Age" :min="0" :max="200"></el-input-number>
					<el-date-picker type="date" placeholder="选择日期" v-model="editForm.Birthday"></el-date-picker>
				</el-form-item>
				<el-form-item label="身高cm:臂长cm:体重kg">
					<el-input-number v-model="editForm.Height" :min="0" :max="200"></el-input-number>
					<el-input-number v-model="editForm.ArmLength" :min="0" :max="200"></el-input-number>
					<el-input-number v-model="editForm.Weight" :min="0" :max="200"></el-input-number>
				</el-form-item>				
					<el-form-item label="电话" prop="Telephone">
					<el-input  v-model="editForm.Telephone" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="身份证号码" >
					<el-input  v-model="editForm.IdNumber" auto-complete="off"></el-input>
				</el-form-item>
				<!-- 卡类型不允许编辑因为跟后续租户所办理的业务相关 -->
				<el-form-item v-if="editForm.CardType==null||Object.keys(editForm.CardType).length==0" label="卡类别" prop="CardType">
					<el-radio-group v-model="editForm.CardType">						
						<el-radio class="radio" :label="0">次卡</el-radio>
						<el-radio class="radio" :label="1">月卡</el-radio>
						<el-radio class="radio" :label="2">年卡</el-radio>
						<el-radio class="radio" :label="3">充值卡</el-radio>
						<el-radio class="radio" :label="4">培训卡</el-radio>
						<el-radio class="radio" :label="5">业主卡</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="editForm.Remark"></el-input>
				</el-form-item>
					<el-form-item label="地址">
					<el-input type="textarea" v-model="editForm.Address"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
		<!--新增界面-->
		<el-dialog title="新增" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="160px" :rules="addFormRules" ref="addForm">
				<el-form-item label="卡号" prop="CardNumber">
					<el-input v-model="addForm.CardNumber" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="Name">
					<el-input v-model="addForm.Name" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="性别">
					<el-radio-group v-model="addForm.Sex">
						<el-radio class="radio" :label="1">男</el-radio>
						<el-radio class="radio" :label="0">女</el-radio>
					</el-radio-group>
				</el-form-item>
				  <el-form-item label="状态" prop="State">
					<el-radio-group v-model="addForm.State">
						<el-radio class="radio" :label="0">启用</el-radio>
						<el-radio class="radio" :label="1">暂停</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="年龄:生日">
					<el-input-number v-model="addForm.Age" :min="0" :max="200"></el-input-number>
					<el-date-picker type="date" placeholder="选择日期" v-model="addForm.Birthday"></el-date-picker>
				</el-form-item>
				<el-form-item label="身高cm:臂长cm:体重kg">
					<el-input-number v-model="addForm.Height" :min="0" :max="200"></el-input-number>
					<el-input-number v-model="addForm.ArmLength" :min="0" :max="200"></el-input-number>
					<el-input-number v-model="addForm.Weight" :min="0" :max="200"></el-input-number>
				</el-form-item>
					<el-form-item label="联系电话" prop="Telephone">
					<el-input  v-model="addForm.Telephone" auto-complete="off"></el-input>
				</el-form-item>
				<!-- <el-form-item label="生日">
				</el-form-item> -->
				<el-form-item label="身份证号码" >
					<el-input  v-model="addForm.IdNumber" auto-complete="off"></el-input>
				</el-form-item>
				
				<el-form-item label="卡类别" prop="CardType">
					<el-radio-group v-model="addForm.CardType">
						
						<el-radio class="radio" :label="0">次卡</el-radio>
						<el-radio class="radio" :label="1">月卡</el-radio>
						<el-radio class="radio" :label="2">年卡</el-radio>
						<el-radio class="radio" :label="3">充值卡</el-radio>
						<el-radio class="radio" :label="4">培训卡</el-radio>
						<el-radio class="radio" :label="5">业主卡</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="备注">
					<el-input type="textarea" v-model="addForm.Remark"></el-input>
				</el-form-item>
					<el-form-item label="地址">
					<el-input type="textarea" v-model="addForm.Address"></el-input>
				</el-form-item>
			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
        
		<el-dialog title="照片管理" v-model="imagemanageVisivle" :close-on-click-modal="false">
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
				<el-form style="float: right;">
					<el-form-item>
						<el-button type="primary" @click="imageShow">上传照片</el-button>
					</el-form-item>						
				</el-form>
		</el-col>
           <el-table :data="ImageList" highlight-current-row v-loading="listLoading">
				<el-table-column  label="照片" width="120" sortable>
						<template slot-scope="scope"  >
					<el-tooltip content="点击查看大图" placement="left" effect="light">
  				 <img   @click="see(scope.row.ImageUrl)"  :src="image(scope.row.ImageUrl)" style="height: 100px; width: 100px; background-image:  background-repeat: no-repeat; background-position: center center; background-size: cover; " >
					</el-tooltip>
				</template>	
				</el-table-column>
			   <el-table-column  prop="CreationTime" label="添加时间" min-width="180"  sortable>
                   
				</el-table-column>	
			<el-table-column label="操作" width="300" fixed="right">
				<template  slot-scope="scope">					
					<el-button type="danger" size="small" @click="imgDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>							
		   </el-table>
		</el-dialog>

			<el-dialog v-model="memberInfoVisible"  title="会员信息" :close-on-click-modal="false">
				<el-form :model="memberInfoForm" label-width="160px"  ref="memberInfoForm">				
					<el-form-item label="卡号" prop="CardNumber">
						<el-input v-model="memberInfoForm.CardNumber" auto-complete="off" :disabled="true"></el-input>
					</el-form-item>
					<el-form-item label="姓名" prop="Name">
						<el-input v-model="memberInfoForm.Name" auto-complete="off" ></el-input>
					</el-form-item>
					<el-form-item label="电话" prop="Telephone">
						<el-input  v-model="memberInfoForm.Telephone" auto-complete="off"></el-input>
					</el-form-item>
					<el-form-item label="套餐名称" prop="ComboName" >
						<el-input v-model="memberInfoForm.ComboName"  placeholder="套餐名称"></el-input>
					</el-form-item>
					<el-form-item label="套餐课时" v-if="memberInfoForm.CardType==4">
						<el-input v-model="ConboModel.ClassHour"  placeholder="套餐课时"></el-input>
					</el-form-item>
					<el-form-item label="操作类型" prop="radioValue">
						<template slot-scope="scope"  >
						<el-radio-group v-model="radioValue" >						
							<el-radio class="radio" :label="0">重置业务卡</el-radio>
							<!-- <el-radio class="radio" :label="1" v-if="memberInfoForm.CardType==4">调整套餐</el-radio> -->
							<el-radio class="radio" :label="2" v-if="memberInfoForm.CardType==4">套餐调班</el-radio>
						</el-radio-group>
						</template>
					</el-form-item>
				<el-form-item label="提示信息"  v-if="radioValue!=-1">
					<span style="color:red" v-if="radioValue==0">重置会员卡所有信息,且删除会员卡信息</span>
					<span style="color:red" v-if="radioValue==1">清除业务信息,保留会员卡信息</span>
					<span style="color:red" v-if="radioValue==2">变更会员卡培训业务的套餐及教练信息,请选择总课时相等的套餐,对应的教练可选可不选</span>
				</el-form-item>
				<el-form-item label="套餐列表-教练列表" v-if="radioValue==2">  
				<el-select v-model="comboId" placeholder="请选择套餐" style="width:49%">
					<el-option
						v-for="item in optionsList"
						:key="item.Id"
						:label="item.Name"
						:value="item.Id" @click.native="TrainingChange">
					</el-option>
				</el-select>
				<el-select style="width:49%" v-model="CoachId" clearable filterable  placeholder="请选择教练" >
					<el-option
						v-for="item in coachOptions"
						:key="item.Id"
						:label="item.Name"
						:value="item.Id">
				 </el-option>
				</el-select>
				</el-form-item>
				<el-form-item label="选中套餐课时" v-if="radioValue==2">	
					<el-input v-model="ClassHour" placeholder="套餐课时" ></el-input>  
				</el-form-item>
			</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click.native="memberInfoVisible = false">取消</el-button>
					<el-button type="primary" @click.native="resetMember" :loading="editLoading">提交</el-button>
				</div>
		</el-dialog>

<!-- 换卡界面 -->
 
  <el-dialog  title="请检查读卡器是否连接" custom-class style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;"  v-model="Machine" :close-on-click-modal="false" >
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
       <div>       
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item >
					<input class="input" ref="siteInput"  v-model="inputIdCard"  clearable @keyup.enter="BusinessHandle" :autofocus="focusvalue" placeholder="卡号" />
				</el-form-item>
				<el-form-item>
					<el-button  type="primary" v-on:click="BusinessHandle" icon="el-icon-search">确认换卡</el-button>
				</el-form-item>				
			</el-form>
		</el-col>
        </div>
    </el-card>
    </el-col>
   </el-row>	
  </el-dialog>

 <!-- 续充 -->
   <el-dialog  title="充值业务卡续充" custom-class style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;"  v-model="RechargeVisible" :close-on-click-modal="false" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
				<el-form-item >  
                  <el-select v-model="RechargeComboId" clearable placeholder="请选择套餐">
                <el-option
                  v-for="item in options"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id" >
               </el-option>
                 </el-select>   
				</el-form-item>
				<el-form-item>
					<el-button  type="primary" v-on:click="RechargeSubmit" icon="el-icon-search">确认续充</el-button>
				</el-form-item>				
			</el-form>	
  </el-dialog>
  <!-- 重置界面 -->
  <el-dialog  title="请检查读卡器是否连接" custom-class style="width:100%;margin: 0 auto;padding-top: 0px;padding-right: 0.25em;padding-bottom: 2ex;padding-left: 0px;"  v-model="ResetMachine" :close-on-click-modal="false" >
     <el-row >
      <el-col :span="25" >
      <el-card :body-style="{ padding: '0px'  }">
      <div > 
          	<el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
        <!-- <span>请检查读卡器</span> -->
				<el-form-item >
					<input class="input" ref="siteInput"  v-model="inputIdCard"  clearable @keyup.enter="GetInFo" :autofocus="focusvalue" placeholder="卡号" />
				</el-form-item>
				<el-form-item>
					<el-button  type="primary" v-on:click="GetInFo" icon="el-icon-search">获取会员信息</el-button>
				</el-form-item>				
			</el-form>
		</el-col>
        </div>
    </el-card>
    </el-col>
   </el-row>	
  </el-dialog>

   <el-dialog
            title="业务延期(延期单位以日计)"
            :visible.sync="visible"
            @close="$emit('update:visible', false)"
            >
            <!-- <span>this is a dialog.</span> -->
            <el-row >
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true"  style="float: right;" @submit.native.prevent>
        <!-- <span>请检查读卡器</span> -->	
                <el-form-item >
					<el-input-number v-model="day" :min="1" :max="20000" placeholder="输入延期天数"></el-input-number>
				</el-form-item>
				<el-form-item >
					<el-input v-model="password" type="password" placeholder="输入操作密码"></el-input>
				</el-form-item>                
				<el-form-item>
					<el-button  type="primary" v-on:click="PostPoneAction" icon="el-icon-search">确认延期</el-button>
				</el-form-item>																	
			</el-form>	
                </el-col>
            </el-row>
        </el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
import {mapGetters} from 'vuex';

	//import NProgress from 'nprogress'
	import {PostPone,GetComboList,BackData,MemberChangeState, Recharge,getRechargeableCardOptionsList,getCoachOptionsList,ResetCardTraining,ResetCardChangeShift, getTrainingCardOptionsList,GetDetails,GetMemberInfoByCard,ImageDelete,ImageGetList,Download,UploadMemberImage,getShopInfor, getMemberListPage, removeUser, batchRemoveUser, editUser, addMember,getShopInfo,editMember ,getMemberCount,ReplaceCard,Reset,ShiftPlan,Backups } from '../../api/api';

	export default {
		data() {
			return {
				daterange1:"",//时间段  搜索条件
				visible:false,
				day:'1',
				password:'',
				Comboid:'',
				comboList:[],
				memberId:'',
				RechargeVisible:false,
				RechargeComboId:'',
				options:[],
			   // 充值 调整 调班相关 
			   radioValue:0,
			   memberInfoVisible:false,
			   memberInfoForm:{
			   },
			   ConboModel:{},
				optionsList:[],
				comboId:'',
				ClassHour:'',
				CoachId:'',
				coachOptions:[],

				imgMemberId:'',
				ImageList:[],
				imagemanageVisivle:false,
				sysUserName:'',
				filters: {
					Name: '',
					dateValue:""
				},
				seeImageVisible:false,
                imgUrl:'',			
				shiftList:[],
				Telephone:'',
				CardNumber:'',
				Count:0,
				options:[],
				Members:[],
				total: 0,
				page: 0,
				listLoading: false,
				sels: [],//列表选中列
				//换卡业务会员id
				ReplaceId:"",
				Machine:false,
				inputIdCard:"",
				focusvalue:false,
				//
				ResetMachine:false,
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					Telephone: [
							{ required: true, message: '请输入手机号', trigger: 'blur' }
					]				
					// ,
					// CardType: [
					// 	{ type:'number', required: true, message: '请选择卡类别'}
					// ]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					CardNumber:'',
					Name: '',
					Sex: -1,
					State:'',
					Age: 0,
					Telephone:'',
					Birthday: '',
					IdNumber:'',
					CardType:'',
					Remark:'',
					Address: '',
					Height:'',	
                    ArmLength:'',	
                    Weight:''			

				},
				addFormVisible: false,//新增界面是否显示
				addLoading: false,
				addFormRules: {
					Name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],				
					CardNumber: [
						{ required: true, message: '请输入卡号', trigger: 'blur' }
					],
					// CardType: [
					// 	{ type:'number', required: true, message: '请选择卡类别'}
					// ],
					// ShopId: [
					// 	{ required: true, message: '请选择门店', trigger: 'blur' }
					// ],
					State: [
						{ type:'number',  required: true, message: '请选择状态'}
					],					
					Telephone: [
							{ required: true, message: '请输入手机号', trigger: 'blur' }
					]
				},
				//新增界面数据
				addForm: {
					CardNumber:'',
					Name: '',
					Sex: -1,
					State:'',
					Age: 0,
					Telephone:'',
					Birthday: '',
					IdNumber:'',
					CardType:'',
					TenancyId:'',
					Remark:'',
					Address: ''	,
					Height:'',	
                    ArmLength:'',	
                    Weight:''			
				},
				UploadImageUrl:'',
				imageVisible:false,
				memberId:'',

			}
			
		},
methods: {
			open (value) {
				this.day=1;
				this.memberId='';
				this.password='';
				this.memberId=value;
			    this.visible=true;
                
            },
            PostPoneAction(){
				let para={
                        memberId:this.memberId,
                        day:this.day,
                        passWord:this.password		
				}
              PostPone(para).then((res)=>{	
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
                                    });
									this.visible=false;
									this.getMember();
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}				  		
			    }).catch(error=>{
                    this.$message({
						message: '延期出现错误',
					    type: 'error'
					 });	
				});
            },	 
	SwitchChange(row){
	   let para={
		   id:row.Id
	   }
	   
			  MemberChangeState(para).then((res)=>{
 						let { Success,Msg } = res.data;
						if(Success)
						{
	                    row.State=row.State==0?1:0;
						this.$message({
							message: Msg,
							type: 'success'
						});
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}  			
					 }).catch(error=>{
			 })		   
	},
			RechargeSubmit(){
				if(this.RechargeComboId=='')
				{
						this.$message({
							message: '请选择套餐',
							type: 'error'
						});					
						return;
				}
				let para={
					MemberId:this.memberId,
					ComboId:this.RechargeComboId
				}
			  Recharge(para).then((res)=>{
 						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: Msg,
							type: 'success'
						});
						this.RechargeVisible=false;
						// this.inputIdCard='';
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}  			
					 }).catch(error=>{
			 })		
		    },
			RechargeShow(row){
				this.RechargeVisible=true;
				this.memberId=row.Id;
				this.GetoptionsList();
			},
			GetoptionsList(){
						let para={
                     }
			  getRechargeableCardOptionsList(para).then((res)=>{
					//  console.log(res);
               this.options=res.data;
				 }).catch(error=>{
				 })
			},
			 resetMember(){
				if(this.radioValue==-1)
				 {
				     this.$message({
							message: '请选择重置方式',
							type: 'error'
						}); 				
				 }
				 if(this.radioValue==0)
				 {
					 this.ResetHandle();
				 }
				 if(this.radioValue==1)
				 {
					 this.ResetHandle2();
				 }
				 if(this.radioValue==2)
				 {
					 if(this.ConboModel.ClassHour!=this.ClassHour)
					 {
                        this.$message({
							message: '课时不相等',
							type: 'error'
						});
						return;
					 }
					 this.ResetShift();
				 }
             
			 },
			ResetShift()
			{
			   let para={
				   	 cardMember:this.inputIdCard,
					 id:this.memberInfoForm.Id,
					 comboId:this.comboId,
					 coachId:this.CoachId

			   }
			   ResetCardChangeShift(para).then((res)=>{
 						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '重置成功',
							type: 'success'
						});
						this.memberInfoVisible=false;
						this.inputIdCard='';
						this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}                  
			   })
			},
              ResetHandle2(){
				  let para={
					 BasicInformationId:this.memberInfoForm.Id,					 
				  }
                 ResetCardTraining(para).then((res)=>{
					  	let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '重置成功',
							type: 'success'
						});
						this.memberInfoVisible=false;
						this.inputIdCard='';
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}  
				 })
   
			  },
			TrainingChange(){
			  
			  let Id=this.comboId;
			  let count='';
              let itemInfo = this.optionsList.filter(function (item) 
	                         {								 
								 if(item.Id===Id)
								 {
									//  console.log(item.Id+'-----'+Id);
                                     count=item.ClassHour;
								 }                                  
                             })
					//   console.log('000'+itemInfo.ClassHour);
			  this.ClassHour=count;	  		      			  
			},
			GetOptionList(){
				let para={}
                  getTrainingCardOptionsList(para).then((res)=>{
					//  console.log(res);
				   this.optionsList=res.data;
				//    console.log(this.optionsList);
				    }).catch(error=>{
				   })					   
                getCoachOptionsList(para).then((res)=>{
					//  console.log(res);
                this.coachOptions=res.data;
				 }).catch(error=>{
                     })  				   
		    },	
			imgDel(index,row){
				let para={
					id:row.Id
				}
				 
				 ImageDelete(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						let newarr=[];
						for(var i=0;i< this.ImageList.length;i++){
							if(this.ImageList[i].Id===row.Id)
							{

							}
							else
							{
                                newarr.push(this.ImageList[i]);
							}
							
						}
						this.ImageList=[];
						this.ImageList=newarr;
						// this.getMember();
						}
						else{
						this.$message({
							message: '删除失败',
							type: 'error'
						});
						}

				}).catch(error=>{					
                 alert('网络错误');
                });
			},
			imagemanage(index,row){
				this.memberId=row.Id;
                this.imagemanageVisivle=true;
                this.imageList(this.memberId);
			},

			imageList(value)
			{
				let para={
					MemberId:value
				}
				// console.log(para);
				ImageGetList(para).then((res)=>{
					// console.log(res);
                  this.ImageList=res.data;
				}).catch(error=>{					
                 alert('网络错误');
                });
			},
			upload(param)
			{
			    var fileObj=param.file;
				var fd=new FormData();
				fd.append("file",fileObj);
				fd.append("memberId",this.memberId)
			  	UploadMemberImage(fd).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						this.imageList(this.memberId);
						// this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
		              
			  }).catch(error=>{
                 alert('网络错误');
                });
			},			
			imageShow()
			{
				// this.memberId=row.Id;
			this.UploadImageUrl=UploadMemberImage;
			// console.log("111"+this.memberId);
			  this.imageVisible=true;			  
			},			  
			see(Image){
                     this.imgUrl=Image;
                  this.seeImageVisible=true;
              },
		  image(imageStr)
		  {

			let  imgUrl=imageStr;
              return imgUrl;
		  },			       
			 ...mapGetters(['getuserstate']),
		getStoryInfo:function(){
					let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
					// console.log(localhoststoryid.storyid);
					let para ={
						TenancyId:TenancyId
					}
           getShopInfor(para).then((res)=>{
						//  console.log(res);
						 let list=res.data;
						 if(list.lenght<1)
						 {
						 }
						 else
						 {					
						 this.sysUserName=res.data[0].Name;
						 }
					 })
		 },
		 handBackData(){
			
		   let para={
				StartDate:this.filters.dateValue.length>0?this.filters.dateValue[0]:'',
				EndDate:this.filters.dateValue.length>0?this.filters.dateValue[1]:'',
		   }
		   BackData(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = "业务数据"; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })
		 },
		 handBackups(){
			if(this.shopId=='')
			{
				this.$message({
					message: "请先选择门店",
					type: 'error'
				});
			}
			else
			{
		   let para={
		   }
		   Backups(para).then((res)=>{		
	   let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
	   var downloadElement = document.createElement('a');
var href = window.URL.createObjectURL(blob); //创建下载的链接
downloadElement.href = href;
downloadElement.download = this.sysUserName; //下载后文件名
document.body.appendChild(downloadElement);
downloadElement.click(); //点击下载
document.body.removeChild(downloadElement); //下载完成移除元素
window.URL.revokeObjectURL(href); //释放掉blob对象
		   })
		   }
			},
			showShift(MemberId)
			   {
				let para={
					MemberId:MemberId,
				}
				 ShiftPlan(para).then((res)=>{
				  this.shiftList=res.data.Data;
				//   console.log(this.shiftList);
			  }).catch(error=>{
                //  alert('网络错误');
                });
			   },
			formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Birthday), 'yyyy-MM-dd');
			},
			formatState: function (row, column) {
				return row.State == 1 ? '暂停' : row.State == 0 ? '启用' : '未知';
			},
			//性别显示转换
			formatSex: function (row, column) {
				return row.Sex == 1 ? '男' : row.Sex == 0 ? '女' : '未知';
			},
			formatType: function (row, column) {
				return row.CardType == 0 ? '次卡' : row.CardType == 1 ? '月卡' : row.CardType == 2 ? '年卡': row.CardType == 3 ? '充值卡': row.CardType == 4 ? '培训卡': row.CardType==5?'业主卡':'未知';
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getMember();
			},
			//获取用户列表
			getCount()
			{
              let para={
                  
			  };
			  getMemberCount(para).then((res)=>{
				  this.Count=res.data.ExtendData;
			  }).catch(error=>{
                 alert('网络错误');
                });
			},
			time(date) {
				console.log(date,"11");
				if(date!="Invalid Date"){
				}else{
					return "";
				}
				var y = date.getFullYear()
            var m = date.getMonth() + 1
            m = m < 10 ? '0' + m : m
            var d = date.getDate()
            d = d < 10 ? '0' + d : d
            var h = date.getHours()
            h = h < 10 ? '0' + h : h
            var minute = date.getMinutes()
            minute = minute < 10 ? '0' + minute : minute
            var second = date.getSeconds()
            second = second < 10 ? '0' + second : second
            return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
			},
			formatTime(format = "", num = new Date().getTime()){
					format = format || "YYYY-mm-dd HH:MM:SS";   //第一个参数不填时，使用默认格式
					let ret, date, renum;
					// 处理时间戳，js一般获取的时间戳是13位，PHP一般是10位,根据实际情况做判断处理
					if (num.toString().length == 10) {
							date = new Date(parseInt(num) * 1000);
					} else {
							date = new Date(parseInt(num));
					}
					const opt = {
							"Y": date.getFullYear().toString(), // 年
							"m": (date.getMonth() + 1).toString(), // 月
							"d": date.getDate().toString(), // 日
							"H": date.getHours().toString(), // 时
							"M": date.getMinutes().toString(), // 分
							"S": date.getSeconds().toString() // 秒
							// 目前用的是这六种符号,有其他格式化字符需求可以继续添加，值必须转化成字符串
					};
					for (var k in opt) {
							ret = new RegExp("(" + k + "+)").exec(format);
							if (ret) {
									renum = (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")) //根据复数前面是否补零,如“mm”补零，单“m”前面不补零
									format = format.replace(ret[1], renum)  //替换
							};
					};
					return format;
			},
			getMember() {
				// console.log("时间区间",this.daterange1);
				// console.log(new Date(this.daterange1[0]),"StartDate");
				// let	StartDate = this.daterange1[0]?this.time(new Date(this.daterange1[0])):"";
				// let	EndDate1 = new Date(this.daterange1[1])
				// console.log(EndDate1,"EndDate1");
				// let	EndDate = this.daterange1[1]?this.formatTime("",EndDate1.setDate(EndDate1.getDate()+1)):"";
				// console.log(StartDate,EndDate)

				// this.getCount();
				let para = {
					StartDate:this.filters.dateValue.length>0?this.filters.dateValue[0]:'',
					EndDate:this.filters.dateValue.length>0?this.filters.dateValue[1]:'',
					PageIndex: this.page-1,					
					PageSize:10,
					Name:this.filters.Name,
					IcCard:this.CardNumber,
					Telephone:this.Telephone,
					ComboId:this.Comboid
				};
				this.listLoading = true;
				//NProgress.start();
				getMemberListPage(para).then((res) => {
					//在浏览器打印出来可以看到 返回的信息应该怎么点
					//结合vsapi写法
					// this.total = res.data.total;
					// this.users = res.data.data;
					//前端mock测试
					console.log(res.data.Data);
					this.total = res.data.TotleCount;
					this.Members =res.data.Data;
                    this.Count=res.data.TotleCount;
					this.listLoading = false;
					//NProgress.done();
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},

		    ResetCard:function(){
				this.inputIdCard='',
				   this.ResetMachine=true;
                  this.focusvalue=true;
                  this.onCellClick(event);
			},

         GetCombo(value){
			 let para={
				 id:value
			 }
			 GetDetails(para).then((res)=>{
			     this.ConboModel= res.data;
			   console.log(res.data);
			 })         
		 },
			//重置前获取会员信息
			GetInFo(row)
			{
                   this.memberInfoForm={};
				   this.radioValue=-1;
				   this.comboId='';
						this.ShowInfo();
						this.memberInfoForm=Object.assign({}, row);
						if(this.memberInfoForm.CardType==4)
						{
							// console.log("model");
						this.GetCombo(this.memberInfoForm.Combo);
						this.GetOptionList();
						}									            
			},
			ShowInfo(){
				this.memberInfoVisible=true;				
			},
            ReplaceCard:function(index,row){
                  this.ReplaceId=row.Id;
				   this.Machine=true;
                  this.focusvalue=true;
                  this.onCellClick(event);
			},            
			//重置业务提交
             ResetHandle(){
				  let para={
				    BasicInformationId:this.memberInfoForm.Id,		
				  }
				  Reset(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
                        this.$message({
							message: Msg,
							type: 'success'
						});
						this.memberInfoVisible=false;
						this.getMember();
						}
						else
						{
                        this.$message({
							message: Msg,
							type: 'error'
						});
						}
				  }).catch(()=>{})
				 this.ResetMachine=false;
				  this.inputIdCard="";
				  this.getMember();
			 },
			//换卡业务提交
             BusinessHandle(){
				  let para={BasicInformationId:this.ReplaceId,
				    AfterCardNumber:this.inputIdCard  
				  }
				  ReplaceCard(para).then((res)=>{
						let { Success,Msg } = res.data;
						if(Success)
						{
                        this.$message({
							message: Msg,
							type: 'success'
						});
						this.getMember();
						}
						else
						{
                        this.$message({
							message: Msg,
							type: 'error'
						});
						}
				  }).catch(()=>{})
				 this.Machine=false;
				  this.inputIdCard="";
			 },
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { id: row.Id 					   
					};
					removeUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						let { Success,Msg } = res.data;
						if(Success)
						{
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getMember();
						}
						else{
						this.$message({
							message: Msg,
							type: 'error'
						});
						}
					});
				}).catch(() => {
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);

			},
			//显示新增界面
			handleAdd: function () {
				this.addFormVisible = true;
				this.addForm = {
					CardNumber:'',
					Name: '',
					Sex: -1,
					State:'',
					Age: 0,
					Telephone:'',
					Birthday: '',
					IdNumber:'',
					CardType:'',
					TenancyId:'',
					Remark:'',
					Address: ''
					
				};
				//   this.getShop();

			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							if(!(/^1[3456789]\d{9}$/.test(this.editForm.Telephone)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }
							this.editLoading = true;
							//NProgress.start();
							
							let para = Object.assign({}, this.editForm);
							// console.log(para);
							para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
							editMember(para).then((res) => {
								this.editLoading = false;
								//NProgress.done();
								// console.log(res);
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								
								this.$refs['editForm'].resetFields();
								this.editFormVisible = false;
								this.getMember();
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						let remind="确认提交吗？";
						if(this.addForm.Sex==-1)
						{
							remind="未选择性别,确认提交吗？";
						}
						this.$confirm(remind, '提示', {}).then(() => {
							//NProgress.start();
							let para= Object.assign({}, this.addForm);	
							 if(!(/^1[3456789]\d{9}$/.test(this.addForm.Telephone)))
							 {
                                this.$message({
									message: '手机号码不正确',
									type: 'error'
								});
                               return ;
							 }
							this.addLoading = true;
							// console.log(para);
							para.Birthday = (!para.Birthday || para.Birthday == '') ? '' : util.formatDate.format(new Date(para.Birthday), 'yyyy-MM-dd');
							addMember(para).then((res) => {							
								this.addLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
								});
								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
								});
								}
								this.$refs['addForm'].resetFields();
								this.addFormVisible = false;
								this.getMember();
							}) .catch(error=>{
                            alert('系统错误');
                            });														
						});
					}
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						//NProgress.done();
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getMember();
					});
				}).catch(() => {
				});
			},
	ComboList(){
		
				  let para={
				  }
				  GetComboList(para).then((res)=>{					  
					this.comboList=res.data.Data;
			
				  }).catch(()=>{})		
	},		
   closeDialog(){
		this.inputIdCard="";
      this.onCellClick(event);
    },
   onCellClick(event)
   {
      this.$nextTick(function(){
         this.$refs['siteInput'].focus();
          // this.$(event.target).children().find("input").focus();
      })
   },
		},
		mounted() {
			this.getMember();
			this.getStoryInfo();
			this.ComboList();
			// this.getCount();
		}
	}

</script>

<style scoped>
 /* .el-form-item {
    margin-bottom: 22px;
    height: 18px;
    } */
	.el-input__inner {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
	width: 300px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
.input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bfcbd9;
    box-sizing: border-box;
    color: #1f2d3d;
    font-size: inherit;
    height: 36px;
    line-height: 1;
    outline: 0;
    padding: 3px 10px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}

</style>


// WEBPACK FOOTER //
// MemberList.vue?46d2a8f6